import { useEffect, useState } from "react";
import { Disc3, Loader2, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { OPEN_WHEEL } from "@/components/LuckyWheel";
import { POINTS_EVENT } from "@/components/PointsBurst";

export function WheelCatchUp() {
  const [w, setW] = useState(null);
  const load = () => api.get("/wheel").then(({ data }) => setW(data)).catch(() => setW({ available: false }));
  useEffect(() => {
    load();
    window.addEventListener(POINTS_EVENT, load);
    return () => window.removeEventListener(POINTS_EVENT, load);
  }, []);
  if (!w) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  return (
    <div className="rounded-3xl bg-gradient-to-br from-rose-50 via-white to-fuchsia-50 border border-pink-100 p-6 text-center space-y-4" data-testid="wheel-catchup">
      <span className="mx-auto w-20 h-20 rounded-full pink-gradient flex items-center justify-center shadow-lg shadow-rose-200 wheel-cta"><Disc3 className="w-10 h-10 text-white" /></span>
      <div>
        <h2 className="font-display text-2xl font-extrabold">Dein tägliches Glücksrad</h2>
        <p className="text-sm text-slate-500 mt-1">Einmal am Tag drehen – {w.multiplier > 1 ? "heute mit doppelten Punkten! 🔥" : `mit Glück knackst du den Jackpot von ${w.jackpot || 0} Punkten.`}</p>
      </div>
      {w.available
        ? <button onClick={() => window.dispatchEvent(new Event(OPEN_WHEEL))} data-testid="wheel-catchup-open" className="w-full h-14 rounded-full pink-gradient text-white text-lg font-extrabold shadow-lg shadow-rose-300 inline-flex items-center justify-center gap-2 active:scale-[0.97] transition-transform"><Sparkles className="w-5 h-5" /> Jetzt drehen</button>
        : <p className="rounded-2xl bg-white border border-pink-100 p-4 text-sm font-semibold text-slate-600" data-testid="wheel-catchup-done">Heute schon gedreht ✓ – morgen wartet ein neuer Dreh auf dich!</p>}
    </div>
  );
}
